import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useGetBrandsQuery } from '../queries/__generated__/getBrands.generated';
import { brandsAtom } from '../brands/state';

export default function useBrands(): void {
  const { data, loading } = useGetBrandsQuery();
  const setBrands = useSetAtom(brandsAtom);

  useEffect(() => {
    if (!loading) {
      setBrands(data?.brand || []);
    }
  }, [loading]);
}
